import React from 'react';
import cn from 'classnames';

import styles from './LoadingStateIcon.module.scss';

export function LoadingStateIcon({ className }: { className?: string }) {
  return <div className={cn(styles.loader, className)} data-target='loadingStateIcon' />;
}
